// extracted by mini-css-extract-plugin
export default {"update":"UpdateInfo_update__3iwXb","update--box":"UpdateInfo_update--box__MJytm","update--text":"UpdateInfo_update--text__utPzL"};